import React, {useState} from "react";
import {useSelector} from "react-redux";
import {useNavigate} from "react-router";
import {useTranslation} from "react-i18next";
import '../log.css'
import {LoadingState} from "../../../../components/fouladyar/loading-state/loadingState";

const AnalyticsLogs = ({data}) => {
    const auth = useSelector((state) => state.auth);
    const {t, i18n} = useTranslation();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);


    return (
        <React.Fragment>

            <div className="nk-content ">
                <div className="container-fluid select-plan-container">

                    <h1>{"لاگ آنالیز اکانت"}</h1>


                    <div className="spacer"/>
                    <h3>
                        در این صفحه لاگ داده های دسته بندی شده این حساب را مشاهده خواهید کرد
                    </h3>
                    <p>
                        دقت داشته باشید این داده ها تنها مربوط به اخرین اکانت فعال این کاربر خواهند بود و داده های گذشته
                        حساب های قبلی از بین رفته اند.
                    </p>


                    <pre className={"log-container"}>
                         {
                             isLoading ? <LoadingState/> :
                                 <code>
                                     {JSON.stringify(data, null, 2)}
                                 </code>
                         }

                    </pre>

                </div>
            </div>
        </React.Fragment>

    );
};

export default AnalyticsLogs;
